import { useFormContext, useWatch } from "react-hook-form";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Typography from "@mui/material/Typography";
import Chip from "@mui/material/Chip";
import TextField from "@mui/material/TextField";
import Paper from "@mui/material/Paper";

export default function QuantiteProduitsVente() {
	const { setValue } = useFormContext();

	const produitsSelectionnes = useWatch({ name: "produitsEnVente" }) || [];

	return (
		<List>
			{produitsSelectionnes.map((produit, index) => (
				<ListItem
					component={Paper}
					variant="outlined"
					key={produit.name}
					sx={{ mb: 1, "& > * ": { mr: 1 } }}
				>
					<Chip
						size="small"
						label={produit.categorie}
					/>
					<Typography>{produit.name}</Typography>
					<TextField
						label="Quantité"
						size="small"
						type="number"
						value={produit.quantite || ""}
						onChange={(e) => {
							const updated = [...produitsSelectionnes];
							updated[index] = {
								...updated[index],
								quantite: parseFloat(e.target.value) || "",
							};
							setValue("produitsEnVente", updated, {
								shouldValidate: true,
							});
						}}
						sx={{ width: 100 }}
					/>
					<Typography>{produit.unite}</Typography>
				</ListItem>
			))}
		</List>
	);
}
